<script setup lang="ts">
import { computed } from 'vue'
import { useAuth } from '@/composables/useAuth.ts'
import { useI18n } from 'vue-i18n'
import { isUserToken } from '@/stores/authStore.ts'
import StatisticsCards from './statistics/StatisticsCards.vue'
import TodoCard from './todo/TodoCard.vue'
import EventsCard from './events/EventsCard.vue'
import CreditorFilter from './CreditorFilter.vue'

const auth = useAuth()
const { t } = useI18n()

const userName = computed(() => {
  if (!isUserToken(auth.selectedToken.value?.payload)) return null
  return auth.selectedToken.value.payload.u_name
})
</script>

<template>
  <div class="pa-4">
    <section class="d-flex align-center mb-6 flex-wrap ga-8">
      <h1 class="text-display-small font-weight-medium">{{ t('common.hello', [userName]) }}</h1>
      <creditor-filter />
    </section>

    <v-fade-transition>
      <div class="dashboard-grid">
        <todo-card class="section-todo" />

        <events-card class="section-events" />

        <statistics-cards class="section-stats" />
      </div>
    </v-fade-transition>
  </div>
</template>

<style scoped>
.dashboard-grid {
  display: grid;
  grid-template-areas:
    'todo events'
    'statistics statistics';
  grid-template-columns: calc(60% - 8px) calc(40% - 8px);
  grid-template-rows: 500px auto;
  gap: 40px 16px;
}

.section-todo {
  grid-area: todo;
}

.section-events {
  grid-area: events;
}

.section-stats {
  grid-area: statistics;
}

@media (max-width: 960px) {
  .dashboard-grid {
    grid-template-areas:
      'todo todo'
      'events events'
      'statistics statistics';
  }
}
</style>
